import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import loc from 'Components/languages';
import Modal from 'Components/modal';
import BrandSelectionListItem from './BrandSelectionListItem.jsx';
import styles from './ModalBrandSelection.less';

class ModalBrandSelection extends PureComponent {
	constructor() {
		super();
		this.modalStyle = {
			content: {
				left: 'calc(50% - 250px)',
				right: 'calc(50% - 250px)',
				maxHeight: '600px',
				padding: 0,
			},
		};
		this.toArray = this.toArray.bind(this);
		this.onSelectBrandHandler = this.onSelectBrandHandler.bind(this);
	}

	toArray(value) {
		if (Array.isArray(value)) {
			return value;
		}
		if (value && value.toArray) {
			return value.toArray();
		}
		return [];
	}

	onSelectBrandHandler(option) {
		this.props.onConfirm(option.value);
	}

	render() {
		const { isOpen, onToggle, salesOrder } = this.props;
		const options = this.toArray(salesOrder.get('brand_selection_options'));
		return (
			<Modal
				title={ loc.selectBrand }
				isOpen={ isOpen }
				onToggle={ onToggle }
				style={ this.modalStyle }
			>
				<div className={ styles.desc }>
					{ loc.clickToSelectBrand }
				</div>
				<div className={ styles.list }>
					<ul className="uk-list uk-list-divider">
						{
							options.map((option, index) => (
								<BrandSelectionListItem
									key={ `modal-brand-selection-option-${index}` }
									option={ option }
									onSelect={ this.onSelectBrandHandler }
								/>
							))
						}
					</ul>
				</div>
			</Modal>
		);
	}
}

ModalBrandSelection.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onToggle: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	salesOrder: PropTypes.instanceOf(Map).isRequired,
};

export default ModalBrandSelection;
